// Pure Bible-reference helpers (no React, no state) shared by the control page.
// Moved verbatim out of ChurchApp.jsx so they can be tested and reused.

// Canonical book names, accepted abbreviations and chapter counts.
export const bibleBooks = {
  'genesis': { name: 'Genesis', abbr: ['gen', 'ge', 'gn'], chapters: 50 },
  'exodus': { name: 'Exodus', abbr: ['exod', 'ex', 'exo'], chapters: 40 },
  'leviticus': { name: 'Leviticus', abbr: ['lev', 'le', 'lv'], chapters: 27 },
  'numbers': { name: 'Numbers', abbr: ['num', 'nu', 'nm', 'nb'], chapters: 36 },
  'deuteronomy': { name: 'Deuteronomy', abbr: ['deut', 'dt'], chapters: 34 },
  'joshua': { name: 'Joshua', abbr: ['josh', 'jos'], chapters: 24 },
  'judges': { name: 'Judges', abbr: ['judg', 'jdg', 'jg'], chapters: 21 },
  'ruth': { name: 'Ruth', abbr: ['rth', 'ru'], chapters: 4 },
  '1 samuel': { name: '1 Samuel', abbr: ['1 sam', '1sa', '1s', 'first samuel'], chapters: 31 },
  '2 samuel': { name: '2 Samuel', abbr: ['2 sam', '2sa', '2s', 'second samuel'], chapters: 24 },
  '1 kings': { name: '1 Kings', abbr: ['1 kgs', '1ki', '1k', 'first kings'], chapters: 22 },
  '2 kings': { name: '2 Kings', abbr: ['2 kgs', '2ki', '2k', 'second kings'], chapters: 25 },
  '1 chronicles': { name: '1 Chronicles', abbr: ['1 chron', '1ch', '1chr', 'first chronicles'], chapters: 29 },
  '2 chronicles': { name: '2 Chronicles', abbr: ['2 chron', '2ch', '2chr', 'second chronicles'], chapters: 36 },
  'ezra': { name: 'Ezra', abbr: ['ezr'], chapters: 10 },
  'nehemiah': { name: 'Nehemiah', abbr: ['neh', 'ne'], chapters: 13 },
  'esther': { name: 'Esther', abbr: ['esth', 'es'], chapters: 10 },
  'job': { name: 'Job', abbr: ['jb'], chapters: 42 },
  'psalms': { name: 'Psalms', abbr: ['psalm', 'ps', 'psa'], chapters: 150 },
  'proverbs': { name: 'Proverbs', abbr: ['prov', 'pr', 'prv'], chapters: 31 },
  'ecclesiastes': { name: 'Ecclesiastes', abbr: ['eccles', 'eccl', 'ec', 'ecc'], chapters: 12 },
  'song of solomon': { name: 'Song of Solomon', abbr: ['song', 'sos', 'so', 'song of songs', 'canticles'], chapters: 8 },
  'isaiah': { name: 'Isaiah', abbr: ['isa', 'is'], chapters: 66 },
  'jeremiah': { name: 'Jeremiah', abbr: ['jer', 'je', 'jr'], chapters: 52 },
  'lamentations': { name: 'Lamentations', abbr: ['lam', 'la'], chapters: 5 },
  'ezekiel': { name: 'Ezekiel', abbr: ['ezek', 'eze', 'ezk'], chapters: 48 },
  'daniel': { name: 'Daniel', abbr: ['dan', 'da', 'dn'], chapters: 12 },
  'hosea': { name: 'Hosea', abbr: ['hos', 'ho'], chapters: 14 },
  'joel': { name: 'Joel', abbr: ['joe', 'jl'], chapters: 3 },
  'amos': { name: 'Amos', abbr: ['am'], chapters: 9 },
  'obadiah': { name: 'Obadiah', abbr: ['obad', 'ob'], chapters: 1 },
  'jonah': { name: 'Jonah', abbr: ['jnh', 'jon'], chapters: 4 },
  'micah': { name: 'Micah', abbr: ['mic', 'mc'], chapters: 7 },
  'nahum': { name: 'Nahum', abbr: ['nah', 'na'], chapters: 3 },
  'habakkuk': { name: 'Habakkuk', abbr: ['hab', 'hb'], chapters: 3 },
  'zephaniah': { name: 'Zephaniah', abbr: ['zeph', 'zep', 'zp'], chapters: 3 },
  'haggai': { name: 'Haggai', abbr: ['hag', 'hg'], chapters: 2 },
  'zechariah': { name: 'Zechariah', abbr: ['zech', 'zec', 'zc'], chapters: 14 },
  'malachi': { name: 'Malachi', abbr: ['mal', 'ml'], chapters: 4 },
  'matthew': { name: 'Matthew', abbr: ['matt', 'mt'], chapters: 28 },
  'mark': { name: 'Mark', abbr: ['mrk', 'mk', 'mr'], chapters: 16 },
  'luke': { name: 'Luke', abbr: ['lk', 'luk'], chapters: 24 },
  'john': { name: 'John', abbr: ['jn', 'jhn'], chapters: 21 },
  'acts': { name: 'Acts', abbr: ['act', 'ac'], chapters: 28 },
  'romans': { name: 'Romans', abbr: ['rom', 'ro', 'rm'], chapters: 16 },
  '1 corinthians': { name: '1 Corinthians', abbr: ['1 cor', '1co', '1 c', 'first corinthians'], chapters: 16 },
  '2 corinthians': { name: '2 Corinthians', abbr: ['2 cor', '2co', '2 c', 'second corinthians'], chapters: 13 },
  'galatians': { name: 'Galatians', abbr: ['gal', 'ga'], chapters: 6 },
  'ephesians': { name: 'Ephesians', abbr: ['eph', 'ephes'], chapters: 6 },
  'philippians': { name: 'Philippians', abbr: ['phil', 'php', 'pp'], chapters: 4 },
  'colossians': { name: 'Colossians', abbr: ['col', 'co'], chapters: 4 },
  '1 thessalonians': { name: '1 Thessalonians', abbr: ['1 thess', '1th', '1 th', 'first thessalonians'], chapters: 5 },
  '2 thessalonians': { name: '2 Thessalonians', abbr: ['2 thess', '2th', '2 th', 'second thessalonians'], chapters: 3 },
  '1 timothy': { name: '1 Timothy', abbr: ['1 tim', '1ti', '1 ti', 'first timothy'], chapters: 6 },
  '2 timothy': { name: '2 Timothy', abbr: ['2 tim', '2ti', '2 ti', 'second timothy'], chapters: 4 },
  'titus': { name: 'Titus', abbr: ['tit', 'ti'], chapters: 3 },
  'philemon': { name: 'Philemon', abbr: ['phlm', 'phm'], chapters: 1 },
  'hebrews': { name: 'Hebrews', abbr: ['heb', 'he'], chapters: 13 },
  'james': { name: 'James', abbr: ['jas', 'jm'], chapters: 5 },
  '1 peter': { name: '1 Peter', abbr: ['1 pet', '1pe', '1 pe', '1pt', 'first peter'], chapters: 5 },
  '2 peter': { name: '2 Peter', abbr: ['2 pet', '2pe', '2 pe', '2pt', 'second peter'], chapters: 3 },
  '1 john': { name: '1 John', abbr: ['1 jn', '1jn', '1j', 'first john'], chapters: 5 },
  '2 john': { name: '2 John', abbr: ['2 jn', '2jn', '2j', 'second john'], chapters: 1 },
  '3 john': { name: '3 John', abbr: ['3 jn', '3jn', '3j', 'third john'], chapters: 1 },
  'jude': { name: 'Jude', abbr: ['jud'], chapters: 1 },
  'revelation': { name: 'Revelation', abbr: ['rev', 're', 'revelations'], chapters: 22 }
};

export const sampleVerses = {
  'john 3:16': 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
  'psalm 23:1': 'The LORD is my shepherd; I shall not want.',
  'romans 8:28': 'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.',
  'philippians 4:13': 'I can do all things through Christ which strengtheneth me.',
  'jeremiah 29:11': 'For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end.',
  'genesis 1:1': 'In the beginning God created the heaven and the earth.',
  'john 14:6': 'Jesus saith unto him, I am the way, the truth, and the life: no man cometh unto the Father, but by me.'
};

// Words a speaker or typist puts in front of a reference ("let us read first
// john 1:9", "please turn to ...", "the book of john 3"). Only a leading run is
// removed, so book names that contain these words ("Song of Solomon") are safe.
// "so", "am", "is" are deliberately absent: they are book abbreviations.
const LEADING_FILLER = new Set([
  'let', 'us', 'lets', "let's", 'please', 'now', 'ok', 'okay', 'we', 'will', 'can', 'you',
  'going', 'turn', 'open', 'your', 'bible', 'bibles', 'look', 'at', 'go', 'to', 'the', 'book', 'of', 'in', '-',
]);

const stripLeadingFiller = (text) => {
  const words = text.split(' ');
  while (words.length > 1 && LEADING_FILLER.has(words[0])) words.shift();
  return words.join(' ');
};

export const parseBibleReference = (text) => {
  let normalized = text.toLowerCase().trim()
    .replace(/\bturn to\b/gi, '')
    .replace(/\bopen (?:your )?(?:bibles? )?to\b/gi, '')
    .replace(/\blook at\b/gi, '')
    .replace(/\bgo to\b/gi, '')
    .replace(/\bread(?:ing)?\b/gi, '')
    .replace(/[,;.!?]/g, '')
    // Strip chapter/verse keywords before book lookup so "john chapter 3" parses correctly
    .replace(/\bchapter\b/gi, ' ')
    .replace(/\bverse(?:s)?\b/gi, ':')
    .replace(/\band\b/g, '-')
    .replace(/\bthrough\b/g, '-')
    .replace(/\s+/g, ' ')
    .trim();

  normalized = stripLeadingFiller(normalized);

  const findBook = (str) => {
    for (const key in bibleBooks) {
      const book = bibleBooks[key];
      const allNames = [key, ...book.abbr];
      for (let i = 0; i < allNames.length; i++) {
        const name = allNames[i];
        if (str.startsWith(name + ' ') || str.startsWith(name + ':') || str === name) {
          return { book, name };
        }
      }
    }
    return null;
  };

  let found = findBook(normalized);
  // "1cor 13:4", "2tim 3:16": an ordinal glued to the book name. Tried only
  // after the plain lookup so abbreviations like "1sa" and "1co" still work.
  if (!found && /^[1-3][a-z]/.test(normalized)) {
    const spaced = normalized.replace(/^([1-3])/, '$1 ');
    found = findBook(spaced);
    if (found) normalized = spaced;
  }

  if (!found) return null;
  const foundBook = found.book;
  const bookKey = found.name;

  let afterBook = normalized.substring(bookKey.length).trim()
    .replace(/\bto\b/g, '-')
    .replace(/\btwenty[-\s]one\b/gi, '21')
    .replace(/\btwenty[-\s]two\b/gi, '22')
    .replace(/\btwenty[-\s]three\b/gi, '23')
    .replace(/\btwenty[-\s]four\b/gi, '24')
    .replace(/\btwenty[-\s]five\b/gi, '25')
    .replace(/\btwenty[-\s]six\b/gi, '26')
    .replace(/\btwenty[-\s]seven\b/gi, '27')
    .replace(/\btwenty[-\s]eight\b/gi, '28')
    .replace(/\btwenty[-\s]nine\b/gi, '29')
    .replace(/\bthirty[-\s]one\b/gi, '31')
    .replace(/\bthirty[-\s]two\b/gi, '32')
    .replace(/\bthirty[-\s]three\b/gi, '33')
    .replace(/\bthirty[-\s]four\b/gi, '34')
    .replace(/\bthirty[-\s]five\b/gi, '35')
    .replace(/\bthirty[-\s]six\b/gi, '36')
    .replace(/\bthirty[-\s]seven\b/gi, '37')
    .replace(/\bthirty[-\s]eight\b/gi, '38')
    .replace(/\bthirty[-\s]nine\b/gi, '39')
    .replace(/\bforty[-\s]one\b/gi, '41')
    .replace(/\bforty[-\s]two\b/gi, '42')
    .replace(/\bforty[-\s]three\b/gi, '43')
    .replace(/\bforty[-\s]four\b/gi, '44')
    .replace(/\bforty[-\s]five\b/gi, '45')
    .replace(/\bforty[-\s]six\b/gi, '46')
    .replace(/\bforty[-\s]seven\b/gi, '47')
    .replace(/\bforty[-\s]eight\b/gi, '48')
    .replace(/\bforty[-\s]nine\b/gi, '49')
    .replace(/\bfifty[-\s]one\b/gi, '51')
    .replace(/\bfifty[-\s]two\b/gi, '52')
    .replace(/\bfifty[-\s]three\b/gi, '53')
    .replace(/\bfifty[-\s]four\b/gi, '54')
    .replace(/\bfifty[-\s]five\b/gi, '55')
    .replace(/\bfifty[-\s]six\b/gi, '56')
    .replace(/\bfifty[-\s]seven\b/gi, '57')
    .replace(/\bfifty[-\s]eight\b/gi, '58')
    .replace(/\bfifty[-\s]nine\b/gi, '59')
    .replace(/\bone\b/gi, '1')
    .replace(/\btwo\b/gi, '2')
    .replace(/\bthree\b/gi, '3')
    .replace(/\bfour\b/gi, '4')
    .replace(/\bfive\b/gi, '5')
    .replace(/\bsix\b/gi, '6')
    .replace(/\bseven\b/gi, '7')
    .replace(/\beight\b/gi, '8')
    .replace(/\bnine\b/gi, '9')
    .replace(/\bten\b/gi, '10')
    .replace(/\beleven\b/gi, '11')
    .replace(/\btwelve\b/gi, '12')
    .replace(/\bthirteen\b/gi, '13')
    .replace(/\bfourteen\b/gi, '14')
    .replace(/\bfifteen\b/gi, '15')
    .replace(/\bsixteen\b/gi, '16')
    .replace(/\bseventeen\b/gi, '17')
    .replace(/\beighteen\b/gi, '18')
    .replace(/\bnineteen\b/gi, '19')
    .replace(/\btwenty\b/gi, '20')
    .replace(/\bthirty\b/gi, '30')
    .replace(/\bforty\b/gi, '40')
    .replace(/\bfifty\b/gi, '50')
    .replace(/\bfirst\b/gi, '1')
    .replace(/\bsecond\b/gi, '2')
    .replace(/\bthird\b/gi, '3')
    .replace(/\s+/g, ' ')
    .trim();

  const match = afterBook.match(/(\d+)\s*[:]*\s*(\d+)?(?:\s*[-]\s*(\d+))?/);

  if (!match) return null;

  const chapter = parseInt(match[1]);
  const verseStart = match[2] ? parseInt(match[2]) : null;
  const verseEnd = match[3] ? parseInt(match[3]) : verseStart;

  return {
    book: foundBook.name,
    chapter: chapter,
    verseStart: verseStart,
    verseEnd: verseEnd,
    reference: `${foundBook.name} ${chapter}${verseStart ? ':' + verseStart : ''}${verseEnd && verseEnd !== verseStart ? '-' + verseEnd : ''}`
  };
};
